export const bconf = () => {
  return {    
    LOGIN: process.env.REACT_APP_LOGIN,
    totalProductPerPage: 50,
  };
};
 